import React, { useState } from 'react';
import './Signup.css';

/**
 * SMS Consent Demo Page
 * 
 * This page demonstrates how SMS consent is captured during user signup.
 * Created for Twilio CTA (Call to Action) compliance review.
 * 
 * This is a demo page only - no data is submitted to any backend.
 */
const SmsConsentDemo = () => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    company_name: '',
    phone: '',
    sms_consent: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  // Demo handlers - these don't actually navigate or submit
  const handleBack = () => {
    // Demo only - no action
  };

  const handleNext = () => {
    // Demo only - no action
  };

  return (
    <div className="page-container">
      <div className="signup-wrapper">
        <h1 className="text-4xl font-bold text-green-700">ZenRent</h1>
        <div className="signup-box">
          <h2 className="text-xl font-semibold text-gray-800">Just a few more details!</h2>
          <input
            type="text"
            name="first_name"
            placeholder="First Name"
            className="mt-3 w-full p-2 border rounded focus:ring-2 focus:ring-green-400"
            value={formData.first_name}
            onChange={handleChange}
          />
          <input
            type="text"
            name="last_name"
            placeholder="Last Name"
            className="mt-3 w-full p-2 border rounded focus:ring-2 focus:ring-green-400"
            value={formData.last_name}
            onChange={handleChange}
          />
          <input
            type="text"
            name="company_name"
            placeholder="Company Name (optional)"
            className="mt-3 w-full p-2 border rounded focus:ring-2 focus:ring-green-400"
            value={formData.company_name}
            onChange={handleChange}
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            className="mt-3 w-full p-2 border rounded focus:ring-2 focus:ring-green-400"
            value={formData.phone}
            onChange={handleChange}
          />
          <div className="sms-consent-container">
            <label className="sms-consent-label">
              <input
                type="checkbox"
                name="sms_consent"
                checked={formData.sms_consent}
                onChange={handleChange}
                className="sms-consent-checkbox"
              />
              <span className="sms-consent-text">
              I agree to receive SMS from ZenRent about my rental (maintenance updates, scheduling, account notifications). Message frequency varies based on activity. Msg & data rates may apply. Reply STOP to opt out, HELP for help. See <a href="/privacy" className="text-green-700 hover:underline">Privacy Policy</a> & <a href="/terms" className="text-green-700 hover:underline">Terms</a>.
              </span>
            </label>
          </div>
          <button
            className="mt-4 w-full p-2 bg-gray-400 text-white rounded hover:bg-gray-500"
            onClick={handleBack}
          >Back</button>
          <button
            className="mt-2 w-full p-2 bg-green-700 text-white rounded hover:bg-green-800"
            onClick={handleNext}
          >Next</button>
        </div>
      </div>
    </div>
  );
};

export default SmsConsentDemo;

